/* src/app/components/payroll/timesheets/timesheet-adjust-void-entry/timesheet-adjust-void-entry.component.css */
::ng-deep ppl-dialog div.popup-dialog.position-dialog div.content.medium {
  width: 90vw;
  max-width: 90%;
}
::ng-deep ppl-dialog div.popup-dialog.position-dialog.limit-dialog-width div.content.medium {
  max-width: 65%;
}
::ng-deep p-calendar.error-border input {
  border: 1px solid red;
}
/*# sourceMappingURL=timesheet-adjust-void-entry.component-XGQJPTV4.css.map */
